export const SET_NOT_PAYING_FILTERS = 'payments/not-paying/setFilters'
export const RESET_NOT_PAYING_FILTERS = 'payments/not-paying/resetFilters'
export const NOT_PAYING_SERVICES = 'payments/not-paying/page'
